<template>
  <div>
    <div class="container">
      <div class="flex">
        <div style="width: 26%">
          <div class="card-right--title">推荐资讯</div>

          <div
            style="
              background: #f0f0f0;
              height: 700px;
              border: 1px solid #e0dcdc;
            "
          >
            <div
              v-for="item in list"
              :key="item.id"
              class="list-item"
              @click="handleItemClick(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="detail-right">
          <div class="">
            <div style="padding: 10px" class="flex items-center">
              <i
                class="el-icon-s-home"
                style="color: #606266; font-size: 16px"
              />

              <div style="color: #606266; font-size: 14px; padding: 0 5px">
                当前位置:
              </div>

              <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in location" :key="item.id">{{
                  item.title
                }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>

          <div style="border: 1px solid #e0dcdc; border-radius: 4px">
            <div class="main-tag" style="">
              {{ nowLocation.title }}
            </div>
          </div>

          <div style="padding: 20px 0">
            <div class="detail__wrap" v-html="detail.content"></div>

            <div
              v-if="detail.annex && detail.annex.length > 0"
              style="color: #666; padding: 20px 0"
            >
              <div><i class="el-icon-paperclip"></i> 附件：</div>
              <span
                v-for="item in detail.annex"
                :key="item.id"
                class="link-item"
                style=""
                @click="handleLinkClick(item)"
              >
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDetailData, fetchListData } from "@/api/home"

export default {
  name: "ListView",

  data() {
    return {
      title: "",
      id: "",

      list: [],
      detail: {},

      location: [],
      nowLocation: {},
      page: 1,
      page_size: 10,
      listData: {},
    }
  },

  watch: {
    $route(to, from) {
      if (
        to.query.content_model_id != from.query.content_model_id ||
        to.query.id != from.query.id
      ) {
        this.getDetail()
      }
    },
  },

  created() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      this.title = this.$route.query.title

      this.id = this.$route.query.id

      this.content_model_id = this.$route.query.content_model_id

      if (this.content_model_id === "1") {
        this.fetchListData()
      } else {
        this.fetchDetailData()
      }
    },

    async fetchListData() {
      try {
        const res = await fetchListData({
          section_id: this.id,
          page: this.page,
          page_size: this.page_size,
        })
        this.list = res.list
        this.detail = res.show
        this.location = res.location || []
        this.nowLocation = this.location[this.location.length - 1] || {}
      } catch (err) {
        console.error("加载失败", err)
      }
    },

    async fetchDetailData() {
      try {
        const res = await fetchDetailData({
          id: this.id,
        })
        this.list = res.list

        this.detail = res.show
        this.location = this.detail.location || []
        this.nowLocation = this.location[this.location.length - 1] || {}
      } catch (err) {
        console.error("加载失败", err)
      }
    },

    handleItemClick(item) {
      this.id = item.id
      this.fetchDetailData()
    },

    handleLinkClick(item) {
      if (item.url) {
        window.open(item.url, "_blank")
      }
    },
  },
}
</script>

<style scoped lang="scss">
.list-item {
  color: #000;
  font-size: 15px;
  padding: 0 10px;
  font-weight: bold;
  line-height: 32px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    // font-weight: bold;
    text-decoration: underline;
  }
}

.card-right--title {
  height: 74px;
  line-height: 74px;
  color: #fff;
  text-align: center;
  // background-color: #005db3;
  background-color: #1d3a98;
}

.detail-right {
  // width: 940px;
  flex: 1;
  background-color: #f2f2f2;
  padding-left: 10px;
  padding-right: 4px;
}

.main-tag {
  display: inline-block;
  padding: 5px 24px;
  // background-color: #003665;
  background-color: #1d3a98;
  color: #fff;
  position: relative;
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #003665;
    position: absolute;
    bottom: -8px;
    right: 50%;
    margin-right: -8px;
  }
}

.title-link {
  &:hover {
    color: #15458b;
    text-decoration: underline;
    cursor: pointer;
  }
}

.link-item {
  font-size: 15px;
  padding-left: 20px;

  &:hover {
    color: #15458b;
    text-decoration: underline;
    cursor: pointer;
  }
}

.detail__wrap ::v-deep img {
  max-width: 100%;
  height: auto;
}
</style>
